import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'inline-flex',
    'items-center',
    'border',
    'text-sm',
    'focus:outline-none',
    'whitespace-nowrap',
    'rounded-md',
    'hover:cursor-pointer',
    'transition-all',
    'duration-300',
    'font-raleway',
    'font-semibold',
  ],
  {
    variants: {
      size: {
        xs: ['text-xs', 'gap-1', 'px-3', 'py-2', 'h-[34px]'],
        sm: ['text-sm', 'gap-1', 'px-4', 'py-2'],
        base: ['text-base', 'gap-2', 'px-4', 'py-3'],
      },
      intent: {
        primary: [
          'bg-white',
          'text-black',
          'border-[3px]',
          'border-[#DC0D15]',
          'hover:bg-[#ECECEC]',
        ],
        black: ['bg-gray-800', 'text-white', 'border-transparent', 'hover:bg-gray-900'],
        white: ['bg-white', 'text-neutral-400', 'border-neutral-400', 'hover:bg-neutral-100'],
      },
      disabled: {
        true: ['!bg-gray-300', '!text-neutral-600', 'hover:!bg-gray-300', 'focus:!bg-gray-300'],
      },
      textAlign: {
        left: [''],
        center: ['justify-center'],
      },
    },
    defaultVariants: {
      intent: 'primary',
      size: 'base',
      textAlign: 'left',
    },
  },
);
